import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import './Login.css'; // Reusing the same CSS file

const SignUpPage = () => {
    const { isDarkTheme } = useTheme();
    const { signUp } = useAuth();
    const navigate = useNavigate();

    const [displayName, setDisplayName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [confirmationSent, setConfirmationSent] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

    setConfirmationSent(false);
    setIsLoading(true);
        try {
            const { session } = await signUp({ email, password, displayName });
            if (session) {
                navigate('/units');
            } else {
                setConfirmationSent(true);
            }
        } catch (err) {
            console.error('Sign-up failed', err);
            setError(err.message || 'Unable to create your account. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={`login-container ${isDarkTheme ? 'dark' : 'light'}`}>
            <div className="login-card">
                <div className="login-header">
                    <h2>Create Your Account</h2>
                    <p className="login-subtitle">Join MathBox and start exploring math in a new way.</p>
                </div>

                {error && <div className="error-message">{error}</div>}
                {confirmationSent && (
                    <div className="error-message" style={{ backgroundColor: 'rgba(34,197,94,0.15)', color: '#16a34a' }}>
                        We sent a confirmation link to {email}. Check your inbox to finish signing up.
                    </div>
                )}

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="displayName">Display Name</label>
                        <input
                            id="displayName"
                            type="text"
                            value={displayName}
                            onChange={(event) => setDisplayName(event.target.value)}
                            placeholder="How should we call you?"
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="you@example.com"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            placeholder="Choose a secure password"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            id="confirmPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                            placeholder="Confirm your password"
                            required
                        />
                    </div>
                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? 'Creating account...' : 'Sign Up'}
                    </button>
                </form>

                <div className="signup-option">
                    <span>Already have an account?</span>
                    <Link to="/login" className="toggle-signup">Sign in</Link>
                </div>
            </div>
        </div>
    );
};

export default SignUpPage;
